import React, { useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import axios from 'axios';

const InvoicesPage = ({ viewerObj, connectedStripeId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { data } = await axios.post('https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com/retrieve-invoices', {
        stripeId: viewerObj.stripeId,
        connectedStripeId
      })
      
      setInvoices(data.invoices)
      setIsLoading(false);
      
    })()
  },[])

  return (
    <Grid
      container 
      item 
      justifyContent="space-between" 
    >
      { isLoading ? 
        <Grid item>
          <i className="fa-solid fa-circle-notch fa-spin fa-xl"></i> 
        </Grid> 
      :
        <>
          { !invoices.length && <p>No receipt's found</p> }

          {
            invoices.map(invoice => {
              return (
                <>
                  <Grid item>
                    <Typography variant="body1" gutterBottom>
                      Posted Date: {invoice.paymentDate}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Amount: ${invoice.amountPaid}
                    </Typography>
                  </Grid>
                  <Grid component={Box} item alignSelf='center' >
                    <Button           
                      variant="contained" 
                      color="primary" 
                      onClick={() => window.location = invoice.invoice_pdf }
                    >
                      Download
                    </Button>
                  </Grid>
                </>
              )
            
            })
          }
        </>
      }
    </Grid>
  )
}

export default InvoicesPage;